// services/ExamResultService.js
import api from "../utils/axios";
import { ENDPOINTS } from "../utils/endpoints";

export function getResults(params = {}) {
    return api.get(ENDPOINTS.RESULTS.BASE, { params });
}
export function getResultById(id) {
    return api.get(ENDPOINTS.RESULTS.BY_ID(id));
}
export function getResultByAttempt(attemptId) {
    return api.get(ENDPOINTS.RESULTS.BY_ATTEMPT(attemptId));
}
export function recomputeResult(attemptId) {
    return api.post(ENDPOINTS.RESULTS.RECOMPUTE(attemptId));
}
export function publishExamResults(examId) {
    return api.post(ENDPOINTS.RESULTS.PUBLISH_BY_EXAM(examId));
}
// Relevé de notes (PDF) - réponse binaire. Pour un compte STUDENT, l'id
// envoyé est ignoré côté serveur (toujours son propre profil) ; peu importe
// donc la valeur passée pour ce cas, "me" convient.
export function downloadResultsTranscript(studentId) {
    return api.get(ENDPOINTS.RESULTS.TRANSCRIPT(studentId), { responseType: "blob" });
}

// `purpose` : "read" (aperçu, permission TRANSCRIPT_READ_*) ou "export" (le PDF va être
// généré : exige TRANSCRIPT_EXPORT_* et l'export est journalisé côté serveur).
export const getTranscriptData = async (studentId, { purpose = "read" } = {}) => {
  return api.get(ENDPOINTS.RESULTS.TRANSCRIPT_DATA(studentId), { params: { purpose } });
};

// Relevé de notes annuel (inscription -> classe -> modules -> matières)
export function downloadAnnualTranscript(studentId, academicYearId) {
    return api.get(ENDPOINTS.RESULTS.ANNUAL_TRANSCRIPT(studentId), {
        params: { academic_year_id: academicYearId },
        responseType: "blob",
    });
}
export function getAnnualTranscriptData(studentId, academicYearId, { purpose = "read" } = {}) {
    return api.get(ENDPOINTS.RESULTS.ANNUAL_TRANSCRIPT_DATA(studentId), {
        params: { academic_year_id: academicYearId, purpose },
    });
}